import { useTheme } from '@daily/shared/contexts/Theme';
import { useAudioLevel, useAudioTrack } from '@daily-co/daily-react';
import { useCallback, useMemo, useRef } from 'react';

import { useCallState } from '/contexts/CallProvider';

interface Props {
  sessionId: string;
}

export const MicMeter: React.FC<Props> = ({ sessionId }) => {
  const { colors } = useTheme();
  const { disableAudio } = useCallState();
  const audioTrack = useAudioTrack(sessionId);

  const audioVolumeRef = useRef<HTMLDivElement>(null);

  const audioTrackForAudioLevel = useMemo(() => {
    if (!process.browser || disableAudio) return null;
    return audioTrack?.persistentTrack;
  }, [audioTrack?.persistentTrack, disableAudio]);

  useAudioLevel(
    audioTrackForAudioLevel,
    useCallback((volume) => {
      if (!audioVolumeRef.current) return;
      audioVolumeRef.current.style.setProperty(
        '--volume',
        `${Math.min(24, 2 * 24 * volume)}px`
      );
    }, [])
  );

  return (
    <div className="volume" ref={audioVolumeRef}>
      <style jsx>{`
        .volume {
          background: ${colors.accent};
          bottom: 0;
          height: var(--volume);
          left: 0;
          position: absolute;
          transition: height 0.15s ease;
          width: 24px;
          z-index: 1;
        }
      `}</style>
    </div>
  );
};
